import * as Sentry from '@sentry/browser';

const initSentry = (dsn, projectId) => {
  const SENTRY_RELEASE_NAME = process.env.SENTRY_RELEASE_NAME;
  if (dsn && SENTRY_RELEASE_NAME) {
    Sentry.init({
      release: `${SENTRY_RELEASE_NAME}`,
      dsn: `https://${dsn}@www.semrush.com/_sentry/${projectId}`,
      ignoreErrors: [
        // Random plugins/extensions
        'top.GLOBALS',
        /Object Not Found Matching Id:/,
        // Avast extension error
        '_avast_submit',
        // sm2
        /globalThis/,
        /__sm2/,
        /WeixinJSBridge/,
        /Munchkin/,
        /ResizeObserver loop completed with undelivered notifications./,
        /ResizeObserver loop limit exceeded/,
        // https://github.com/getsentry/sentry-javascript/issues/2546
        'Non-Error exception captured',
        'Non-Error promise rejection captured',
      ],
      denyUrls: [
        // sm2
        /\/__static__\/webpack/,
        // gtm
        /\/gtm.js/,
        // Google Adsense
        /pagead\/js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        // Localhost
        /127\.0\.0\.1/i,
        /localhost/i,
      ],
      allowUrls: [/(https?:\/\/\s\.)?semrush\.com/],
      tracesSampleRate: 0.75,
      beforeSend(event, hint) {
        const error = hint.originalException;
        // filter for recaptcha errors - https://github.com/getsentry/sentry-javascript/issues/2514
        if (error === 'Timeout') return null;
        return event;
      },
    });
  }
};

export default initSentry;
